<button type="button" id="btnApprove" (click)="approveConfirm()" style="display:none">ApproveConfirm</button>
<div class="row">
  <div id="LoadingImagePopupInfo">
    <img src="assets/Images/loader.gif" class="imgLoadimg" />
  </div>
  <div id="divArtInfo" class="col">
    <div class="row">

      <div id="divLoadData" class="col-sm-12 fixTableHead">

        <table id="tblArticle" class="dataTable table" style="width: 100%" *ngIf="ViewMode=='New'">
          <thead>
            <tr>
              <th>#</th>
              <th>Article</th>
              <th>Title</th>
              <th>Journal</th>
              <th style="text-align:center">Status</th>
              <th style="text-align:center">Info</th>
              <th style="text-align:center">Actions</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
        <div *ngIf="ViewMode=='Old'">
          <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul" role="tablist">
            <li class="nav-item"> <a data-toggle="tab" href="#ArticleTab" name="Config" class="nav-link active">Article Info</a></li>
            <li class="nav-item"><a data-toggle="tab" href="#ProofingTab" name="Reminder" class="nav-link">Proofing</a></li>
          </ul>
          <div class="tab-content">
            <div id="ArticleTab" class="tab-pane active">
              <table id="tblArticleInfo" class="dataTable table" style="width: 100%">
                <tbody>
                </tbody>
              </table>
            </div>
            <div id="ProofingTab" class="tab-pane">
              <table id="tblArticleOld" class="dataTable table" style="width: 100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>ARTICLE</th>
                    <th>STAGE</th>
                    <th style="text-align:center">DOWNLOAD PROOF</th>
                    <th style="text-align:center">ONE MORE REVIEW</th>
                    <th style="text-align:center">CORRECTION</th>
                    <th style="text-align:center">NO CORRECTION</th>
                    <th style="text-align:center">Status</th>
                  </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <hr />
      <div class="col-sm-12 fixTableHead" id="divInstructions">
        <h4>Return corrections:</h4>
        <ul>
          <li>Make your corrections in the proof PDF using Adobe commenting tools.</li>
          <li>Once you have completed the review, upload the correction file by clicking the "Correction" button.</li>
          <li>
            If there are any changes to the figures, please use the Attach File option in PDF reader and upload the figure to embed it in the PDF.
            The figure will be checked and replaced as appropriate in the subsequent stages of production.
          </li>
          <li>
            If you have submitted an incorrect file by mistake, please email the correct files to
            <a id="aprdEmail" href="{{journalEmail}}">{{journalEmail}}</a>.
          </li>
          <li>You can also download and verify your correction file by clicking the "Correction" button once you have submitted the corrections successfully.</li>
        </ul>
      </div>
    </div>
  </div>

</div>

<div id="myModal_Corrections" class="modal" role="dialog" [style.display]="showCorrectionModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Corrections</h4>

      </div>
      <div class="modal-body" name="correctionPopup">
        <div class="col">
          <div class="form-group col CorrectionInputInstructions">
            <label for="TxtInstruction">Instructions</label>
            <textarea class="form-control rounded-0" id="TxtInstruction" rows="5"></textarea>
          </div>
          <div class="form-group col CorrectionInputFile">
            <label for="FU_Attchment">Correction File</label>
            <div class="custom-file">
              <input type="file" id="FU_Attchment" (change)="fileChangeEvent($event)">
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" style="display:none" id="btnPMCorrections" (click)="updateArticleCorrection()">Upload</button>
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnCorrectionConfirm" (click)="CorrectionConfirm()">Upload</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideCorrectionModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopup1">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>


<div id="myModal_Info" class="modal" role="dialog" [style.display]="showCorrectionModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Proof Info</h4>

      </div>
      <div class="modal-body">

        <div class="row">
          <div class="col-sm-12">
            <div id="divLoadData" style="overflow-x:auto;">
              <table class="tblMain" id="tblMain" width="100%">
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer">

        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideInfoModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopup1">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>
